export default __webpack_public_path__ + "static/media/laundryBag.3cc76e71.jpg";